<script setup>
import TransactionHistoryIndex from "@/components/transaction-history/TransactionHistoryIndex.vue";

definePage({
  meta: {
    layout: "default",
  },
});
const pageTitle = "Transaction History";

const breadCrumbs = [
  {
    title: "Dashboard",
    to: "/admin/dashboard",
  },
  {
    title: "Report",
    to: null,
  },
  {
    title: pageTitle,
    to: null,
  },
];
</script>

<template>
  <VBreadcrumbs :items="breadCrumbs" class="px-0 pt-0 pb-5" />
  <h4 class="text-h4 my-4">Search {{ pageTitle }}</h4>
  <VCard>
    <VCardText>
      <TransactionHistoryIndex />
    </VCardText>
  </VCard>
</template>
